import { render, staticRenderFns } from "./BankPopup.vue?vue&type=template&id=2b191bd8&scoped=true"
import script from "./BankPopup.vue?vue&type=script&lang=js"
export * from "./BankPopup.vue?vue&type=script&lang=js"
import style0 from "./BankPopup.vue?vue&type=style&index=0&id=2b191bd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b191bd8",
  null
  
)

export default component.exports